
import { mapGetters } from "vuex";
import VueSelect from "vue-select";
import _ from "lodash";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { mapActions } from "vuex";

import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-servico-create",
  components: {
    VueSelect,
    Money,
  },
  props: {
    redirectOnSave: {
      type: Boolean,
      default: true,
    },
    requireDuration: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        horimetro: false,
        valor: 0,
        valor_hora: 0,
        observacao: "",
      },
      codServicoSelected: null,
      configMask: settingMoney,
      tabIndex: 0,
      render: 0,
      servicoError: false,
      tributacaoError: false,
      discriminacaoFilled: null,
      durationFilled: null,
      valorFilled: null,
      durationOptions: [
        { value: null, text: "Sem duração" },
        ...Array.from({ length: 8 }, (_, index) => {
          const value = (index + 1) * 15;
          const hours = Math.floor(value / 60);
          const minutes = value % 60;
          const text =
            value < 60
              ? `${value} minutos`
              : minutes
              ? `${hours}h${String(minutes).padStart(2, "0")}`
              : `${hours} hora${hours > 1 ? "s" : ""}`;

          return {
            value,
            text,
          };
        }),
      ],
      valorHoraFilled: null,
      codServicoOptions: [],
      tributacaoOptions: [],
      tributacaoSelected: null,
      tributacaoTipos: [],
      tributacao: null,
      exigibilidade: null,
      exigibilidadeTipos: [],
      regras: [],
      municipioSelected: null,
      municipioToAdd: {
        aliquota_iss: null,
        retencao_iss: null,
      },
      operacoesPessoal: [
        {
          value: 1,
          descricao: "Sim",
        },
        {
          value: 2,
          descricao: "Não",
        },
      ],
      tiposOperacao: [
        {
          value: 1,
          descricao: "Fornecimento com pagamento posterior",
        },
        {
          value: 2,
          descricao: "Recebimento do pagamento com fornecimento já realizado",
        },
        {
          value: 3,
          descricao: "Fornecimento com pagamento já realizado",
        },
        {
          value: 4,
          descricao: "Recebimento do pagamento com fornecimento posterior",
        },
        {
          value: 5,
          descricao: "Fornecimento e recebimento do pagamento concomitantes",
        },
      ],
      tiposEnteGovernamental: [
        {
          value: 1,
          descricao: "União",
        },
        {
          value: 2,
          descricao: "Estado",
        },
        {
          value: 3,
          descricao: "Distrito Federal",
        },
        {
          value: 4,
          descricao: "Município",
        },
      ],
    };
  },

  mixins: [SistemaMixin],
  computed: {
    ...mapGetters(["itsblocked"]),
    isUpdateServico() {
      return !!this.$route.params?.servicoData;
    },
    valorError() {
      return this.form.valor === 0;
    },
  },
  watch: {
    "form.horimetro"(value) {
      if (value) {
        this.$set(this.form, 'valor', 0);
        this.valorFilled = null;
        return;
      }

      this.$set(this.form, 'valor_hora', 0);
      this.valorHoraFilled = null;
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },
    setCodServico(value) {
      this.form.codigo = value.codigo;
      this.codServicoSelected = value;
      this.servicoError = false;
    },
    setTributacao(value) {
      this.tributacaoSelected = value;
      this.form.id_tributacao_servico = value.id_tributacao_servico;
      this.tributacaoError = false;
    },
    addMunicipioISS() {
      this.regras.push({
        cidade:
          this.municipioSelected.cidade + " - " + this.municipioSelected.uf,
        id_cidade: this.municipioSelected.id_cidade,
        aliquota_iss: this.municipioToAdd.aliquota_iss,
        retencao_iss: this.municipioToAdd.retencao_iss,
      });
      this.municipioSelected = null;
      this.municipioToAdd.aliquota_iss = null;
      this.municipioToAdd.retencao_iss = null;
      this.$bvModal.hide("modal-iss-cidade");
    },
    handleDeleteIss(data) {
      this.regras = this.regras.filter(
        (regra) => regra.id_cidade !== data.id_cidade
      );
    },
    onSearchTributacao(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchTributacao(loading, search, this);
      }
    },
    searchTributacao: _.debounce(async (loading, search, vm) => {
      const response = await vm.$http.post(
        "/tributacaoservico/tributacao-by-description",
        {
          descricao: search,
        }
      );
      vm.tributacaoOptions.splice(
        0,
        vm.tributacaoOptions.length,
        ...response.data
      );
      loading(false);
    }, 500),
    onSearchCodServico(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchCodServico(loading, search, this);
      }
    },
    searchCodServico: _.debounce(async (loading, search, vm) => {
      const response = await vm.$http.post(
        "/tributacaoservico/get-codigo-servico",
        {
          search,
        }
      );
      vm.codServicoOptions.splice(
        0,
        vm.codServicoOptions.length,
        ...response.data
      );
      loading(false);
    }, 500),
    isHorimetroActive(value) {
      return value === true || value === 1 || value === '1';
    },
    normalizeHorimetroFields() {
      this.$set(this.form, 'horimetro', this.isHorimetroActive(this.form.horimetro));
      this.$set(this.form, 'valor_hora', this.form.valor_hora || 0);

      if (this.form.horimetro) {
        if (!this.form.valor_hora && this.form.valor) {
          this.$set(this.form, 'valor_hora', this.form.valor);
        }

        this.$set(this.form, 'valor', 0);
        return;
      }

      this.$set(this.form, 'valor_hora', 0);
    },

    async getDataInit() {
      this.setLoading(true);
      const responseTributacao = await this.$http.post(
        "/tributacaoservico/get-tipos-tributacao"
      );
      const responseExigibilidadeTipos = await this.$http.post(
        "/tributacaoservico/get-exigibilidade-tributacao"
      );
      this.tributacaoTipos = responseTributacao.data;
      this.exigibilidadeTipos = responseExigibilidadeTipos.data;

      if (this.isUpdateServico) {
        const servicoData = this.$route.params.servicoData;
        const tributacaoData = this.$route.params.tributacaoData;
        this.form = { ...servicoData };
        this.tributacaoSelected = tributacaoData;
        this.codServicoSelected = servicoData.codigo_servico;
        this.render++;
      }
      this.normalizeHorimetroFields();
      this.setLoading(false);
    },
    async onSubmit() {
      let haveAnyError = false;

      this.addLoadingToButton("submit_novo_servico");
      if (!this.codServicoSelected) {
        this.removeLoadingToButton("submit_novo_servico");
        this.$toast.error("Preencha o serviço!");
        this.servicoError = true;
        haveAnyError = true;
      }

      if (!this.tributacaoSelected) {
        this.removeLoadingToButton("submit_novo_servico");
        this.$toast.error("Preencha a tributação!");
        this.tributacaoError = true;
        haveAnyError = true;
      }

      if (!this.form.discriminacao) {
        this.removeLoadingToButton("submit_novo_servico");
        this.$toast.error("Discriminação obrigatória!");
        haveAnyError = true;
        this.discriminacaoFilled = false;
      }

      if (this.requireDuration && !this.form.duracao_minutos) {
        this.removeLoadingToButton("submit_novo_servico");
        this.$toast.error("Duração obrigatória para agendamento!");
        haveAnyError = true;
        this.durationFilled = false;
      }

      if (this.form.valor === 0 && !this.form.horimetro) {
        this.removeLoadingToButton("submit_novo_servico");
        this.$toast.error("Valor tem que ser maior que 0!");
        haveAnyError = true;
        this.valorFilled = false;
      }
      
      if (this.form.horimetro && Number(this.form.valor_hora || 0) === 0) {
        this.removeLoadingToButton('submit_novo_servico')
        this.$toast.error('Valor hora tem que ser maior que 0!')
        haveAnyError = true;
        this.valorHoraFilled = false;
      }

      if (haveAnyError) return;

      this.normalizeHorimetroFields();

      const dataToSave = {
        ...this.form,
        id_tributacao_servico: this.tributacaoSelected.id_tributacao_servico,
        codigo: this.codServicoSelected.codigo,
        id_codigo_servico: this.codServicoSelected.id_codigo_servico,
        valor: this.form.horimetro ? this.form.valor_hora : this.form.valor,
        horimetro: !!this.form.horimetro,
      }
      delete dataToSave.valor_hora;

      try {
        let response = null;
        if (this.isUpdateServico) {
          response = await this.$http.post("/servicos/update", dataToSave);
          this.$toast.success("Serviço atualizado com sucesso!");
        } else {
          response = await this.$http.post("/servicos/create", dataToSave);
          this.$toast.success("Serviço salvo com sucesso!");
        }
        this.$emit("saved", {
          response: response?.data,
          form: dataToSave,
        });

        if (this.redirectOnSave) {
          this.$router.push({ name: "servicos" });
        }
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("submit_novo_servico");
    },
  },
  created() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
};
